import { SMSCustomerConfig } from "@missionlabs/smartagent-service-sms/dist/entities/sms-configuration"
import { IWhatsAppCustomerConfig } from "@missionlabs/smartagent-service-whatsapp/dist/lib/entities/whatsapp-customer-config";

export interface MessagingConfigs {
    [key: string]: MessagingConfig[]
}

export type MessagingConfig = SMSConfig | WhatsAppConfig

export interface SMSConfig extends SMSCustomerConfig {
    channel: "SMS"
}

export interface WhatsAppConfig extends IWhatsAppCustomerConfig {
    channel: "WHATSAPP"
}

export enum ChannelSettingsMessagingTypes {
    SET_MESSAGING_CONFIGS = "channelSettings/SET_MESSAGING_CONFIGS",
    SET_MESSAGING_CONFIGS_LOADING = "channelSettings/MESSAGING_CONFIGS_LOADING",
    SET_SELECTED_MESSAGING_CONFIG = "channelSettings/SET_SELECTED_MESSAGING_CONFIG",
    SET_MESSAGING_PINPOINT_NUMBERS = "channelSettings/SET_MESSAGING_PINPOINT_NUMBERS",
    SET_WHATSAPP_ACCESS_CODE = "channelSettings/SET_WHATSAPP_ACCESS_CODE"
}
